@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  :global(.ant-modal-body) {
    padding: 24px;
  }

  :global(.ant-modal-header) {
    border: 0;
  }

  :global(.ant-modal-footer) {
    border: 0;
    padding: 16px;
  }

  :global(.ant-modal-content) {
    border-radius: 16px;
  }

  .header {
    margin-bottom: 12px;
  }

  .body {
    .title {
      @include xxl-semibold;
      padding: 0;
      margin: 0 0 12px 0;
    }

    .description {
      @include lg-regular;
      margin-bottom: 28px;
    }

    .form {
      display: grid;
      grid-template-columns: auto auto 1fr;
      row-gap: 4px;

      .cell {
        display: flex;
        align-items: center;

        &.separator {
          padding: 0 8px;
        }
      }

      .columnHeader {
        @include sm-medium;
        color: $grey-40;
        padding-left: 2px;
      }

      .selectButton {
        padding-left: 2px;
      }
    }
  }

  .footer {
    .buttonsWrapper {
      display: flex;
      justify-content: space-between;
    }
  }
}
